import React from 'react'
import { Box, Stack, Typography, Button } from '@mui/material'
import { motion } from 'framer-motion'
import { TypeAnimation } from 'react-type-animation'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'
import vedio from '../Images/burj-khalifa-skyscraper.mp4'

export const HeroSection = () => {
  const { t, i18n } = useTranslation()
  const navigate = useNavigate()
  const isArabic = i18n.language.startsWith('ar')
  const locations = t('hero.locations', { returnObjects: true })
  const typeSequence = locations.flatMap((loc) => [loc, 2000])

  // بتنزل بسلاسة للسيكشن اللي بعد الهيرو مباشرة بدل ما محتاجين نعمل navigate فعلي
  const handleScrollDown = () => {
    const heroHeight = window.innerHeight
    window.scrollTo({ top: heroHeight, behavior: 'smooth' })
  }

  return (
    <Box sx={{ position: 'relative', width: '100%', height: '100vh', overflow: 'hidden', bgcolor: '#2B2B2B' }}>
      <Box
        component="video"
        autoPlay
        muted
        loop
        playsInline
        sx={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          zIndex: 0,
        }}
      >
        <source src={vedio} type="video/mp4" />
      </Box>

      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          zIndex: 1,
          background:
            'linear-gradient(180deg, rgba(43,43,43,0.6) 0%, rgba(122,46,58,0.25) 45%, rgba(43,43,43,0.9) 100%)',
        }}
      />

      {/* طبقة الدمج مع السكشن اللي بعده */}
      <Box
        sx={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          height: { xs: '150px', md: '280px' },
          zIndex: 2,
          background: 'linear-gradient(180deg, rgba(43,43,43,0) 0%, #2B2B2B 100%)',
          pointerEvents: 'none',
        }}
      />

      <Stack
        component={motion.div}
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: false, amount: 0.4 }}
        transition={{ duration: 1, ease: 'easeOut' }}
        alignItems="center"
        textAlign="center"
        spacing={3}
        sx={{ position: 'relative', zIndex: 10, height: '100%', justifyContent: 'center', px: 2 }}
      >
        <Typography
          variant="h1"
          sx={{
            fontFamily: isArabic ? "'El Messiri', serif" : "'Bodoni Moda', serif",
            fontWeight: isArabic ? 700 : 600,
            fontSize: { xs: '2.5rem', md: '5.5rem' },
            lineHeight: 1.1,
            color: '#fff',
          }}
        >
          {t('hero.titleLine1')}
          <br />
          {t('hero.titleLine2')}
        </Typography>

        <Typography variant="body1" sx={{ color: '#fff', maxWidth: 480 }}>
          {t('hero.subtitle')}
        </Typography>

        <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
          <Button
            onClick={() => {
              console.log('EXPLORE BUTTON CLICKED')
              navigate('/projects')
            }}
            variant="contained"
            sx={{
              bgcolor: '#7A2E3A',
              color: '#D9D6CF',
              px: 4,
              py: 1.5,
              borderRadius: '999px',
              '&:hover': { bgcolor: '#8f3646' },
            }}
          >
            {t('hero.explore')}
          </Button>
          <Button
            onClick={() => navigate('/contact')}
            variant="outlined"
            sx={{
              borderColor: 'rgba(217,214,207,0.4)',
              color: '#D9D6CF',
              px: 4,
              py: 1.5,
              borderRadius: '999px',
              '&:hover': { borderColor: '#D9D6CF' },
            }}
          >
            {t('hero.catalog')}
          </Button>
        </Stack>

        <Typography
          variant="body2"
          sx={{ color: 'rgba(217,214,207,0.75)', display: 'flex', gap: 1, alignItems: 'center' }}
        >
          {t('hero.eyebrow')}
          <Box component="span" sx={{ color: '#fff', fontWeight: 700 }}>
            <TypeAnimation sequence={typeSequence} wrapper="span" speed={50} repeat={Infinity} />
          </Box>
        </Typography>
      </Stack>

      <Box
        component={motion.div}
        onClick={handleScrollDown}
        animate={{ y: [0, 8, 0] }}
        transition={{ repeat: Infinity, duration: 1.8, ease: 'easeInOut' }}
        sx={{
          position: 'absolute',
          bottom: 32,
          left: '50%',
          transform: 'translateX(-50%)',
          zIndex: 10,
          color: 'rgba(217,214,207,0.6)',
          cursor: 'pointer',
        }}
      >
        <ArrowDownwardIcon />
      </Box>
    </Box>
  )
}
